export default __webpack_public_path__ + "images/referrals-onboarding-step-3_2x.da3a948e1e8bf5da5ed9d9aea1790f4e.png";